module.exports = __webpack_public_path__ + "img/checkup-gift4.ccf073a7.png";